var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74964 10.25L16.4996 1.50002M7.85596 10.5234L10.0461 16.1551C10.239 16.6512 10.3355 16.8993 10.4745 16.9717C10.595 17.0345 10.7385 17.0345 10.8591 16.9719C10.9982 16.8997 11.0949 16.6517 11.2884 16.1558L16.7804 2.08269C16.9551 1.63504 17.0424 1.41121 16.9946 1.26819C16.9532 1.14398 16.8557 1.04651 16.7315 1.00501C16.5885 0.957234 16.3646 1.04458 15.917 1.21927L1.84386 6.71122C1.34796 6.90474 1.10001 7.0015 1.02775 7.14059C0.965115 7.26116 0.9652 7.4047 1.02798 7.5252C1.1004 7.66421 1.34846 7.76067 1.84458 7.95361L7.47625 10.1437C7.57696 10.1829 7.62731 10.2024 7.66972 10.2327C7.7073 10.2595 7.74016 10.2924 7.76697 10.3299C7.79721 10.3723 7.8168 10.4227 7.85596 10.5234Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.dab8867738a3ea29e305aab1e94478f2.svg";
export { ForwardRef as ReactComponent };